import _ from "underscore";
import {Promise} from "es6-promise";

export default function (urls: string[]) {
    const promises = _.map(urls, (url: string) => {
        return new Promise(resolve => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => resolve();
            img.src = url;
        });
    });
    return Promise.all(promises);
}
